import styled from 'styled-components'

export const Wrapper = styled.div``

export const Title = styled.div`
  color: #213f68;
  font-size: 18px;
  font-weight: 700;
`

export const Description = styled.div`
  color: #363636;
  margin-top: 16px;
`

export const Container = styled.div`
  border: 1px solid #d9d9d9;
  margin-top: 16px;
  padding: 24px;
  border-radius: 16px;
`

export const Subtitle = styled.div`
  color: #213f68;
  font-weight: 700;
`
